/************
 Adjust title size
 ************/
// dynamically adjusts the title to fit just under the width of the container
function adjustFontSize() {

    // get container and text to adjust
    let container = document.querySelector('#productInnerContent');
    let text = document.querySelector('#productInnerContentTitle');

    // Calculate the initial font size width
    let fontSize = parseFloat(window.getComputedStyle(text).fontSize);


    // Adjust font size to fit the container width
    while (text.offsetWidth >= container.offsetWidth) {
        fontSize -= 1;
        text.style.fontSize = fontSize + 'px';
    }
}

// only run for mobile
if (window.innerWidth < 801) {
    adjustFontSize();
}


/************
 Product Swiper
 ************/

// setup product swiper
let productImages = new Swiper("#productInnerVisualBodySwiper", {
    pagination: {
        el: "#productInnerVisualBodySwiperPagination",
        clickable: true,
    },
    spaceBetween: 10,
    navigation: {
        nextEl: "#product .swiper-button-next",
        prevEl: "#product .swiper-button-prev",
    },
})
// thumbnail

// thumbnail swiper default
let thumbnailSwiper = new Swiper("#productInnerVisualBodyThumbsSwiper", {
    navigation: {
        nextEl: '#productInnerVisualBodyThumbsControlsBtn',
    },
    direction: 'vertical',
    slidesPerView: 5,
    spaceBetween: 12,

});


// thumbnail click event change main swiper slide
document.querySelectorAll(".productInnerVisualBodyThumbsSwiperWrapperItem").forEach(function (element) {
    element.addEventListener("click", function () {
        // determine index
        let index = getElIndex(this);
        // change active slide
        productImages.slideTo(index);
    });
});

/**************
 Keep track of unchecked options
 ***************/

// get list of unchecked options - they're all initially unchecked
let radios = new Set();
let inputs = document.querySelectorAll("#product select, #product input")
// Iterate through radios and collect unique group names
inputs.forEach(function (radioButton) {
    radios.add(radioButton.name);
});
let uncheckedOptions = Array.from(radios);
for (let i = 0; i < uncheckedOptions.length; i++) {
  let element = document.querySelector(`[data-target="${CSS.escape(uncheckedOptions[i])}"]`);
}

/**************
 Product Variants
 ***************/
let quantity = 1;


// update active variant on input changes
document.querySelectorAll("#product select, #product input").forEach(function (element) {
    element.addEventListener("change", function () {
        // pass in target, which is used to find the element to update (label changes)
        updateProduct(this.dataset.target);

        // remove group from unchecked options array - it has been checked
        uncheckedOptions = uncheckedOptions.filter(item => item !== this.name);

        // hide error message if it exists
        let target = this.dataset.target;
        let targetElement = document.querySelector(`[data-target="${CSS.escape(target)}"]`);
        if (targetElement) {
            targetElement.classList.remove("active");
        }
    });
})
// Call updateProduct() immediately to make sure first variant is available
updateProduct();

/*Compatibility with Unbridaled app*/
function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function updateQueryString(key, value, url) {
    if (!url) url = window.location.href;

    let updated = '';
    var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
        hash;
            
    if (re.test(url)) {
        if (typeof value !== 'undefined' && value !== null) {
            updated = url.replace(re, '$1' + key + "=" + value + '$2$3');
        }
        else {
            hash = url.split('#');
            url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
            if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
                url += '#' + hash[1];
            }
            updated = url;
        }
    }
    else {
        if (typeof value !== 'undefined' && value !== null) {
            var separator = url.indexOf('?') !== -1 ? '&' : '?';
            hash = url.split('#');
            url = hash[0] + separator + key + '=' + value;
            if (typeof hash[1] !== 'undefined' && hash[1] !== null) {
                url += '#' + hash[1];
            }
            updated = url;
        }
        else {
            updated = url;
        }
    }

    window.history.replaceState({ path: updated }, '', updated);
}

function trigger(e, colorOption, shapeOption){
  let shape = '';
  let color = '';

  if (e.target.getAttribute("data-target") === 'Color') {
      color = e.target.getAttribute("value");
      shape = document.querySelector('input[name="Shape"]:checked').value.toLowerCase();
  } else if (e.target.getAttribute("data-target") === 'Shape'){
      color = document.querySelector('input[name="Color"]:checked').value.toLowerCase();
      shape = e.target.getAttribute("value");
  }
  const variants = document.querySelectorAll('select[data-variants] option');
  let variantId = document.querySelectorAll('select[data-variants] option')[0].value;

  variants.forEach((variant) => {
      if ( variant.getAttribute('data-' + colorOption) === color && variant.getAttribute('data-' + shapeOption) === shape ){
          variantId = variant.value;
          document.querySelector('[name="all-variants"]').value = variant.value;
      }
  })
  updateQueryString('variant', variantId);
}

if (document.querySelector(".unbridaled-form")){
  uncheckedOptions = [];
  document.querySelector("#productATC").textContent = "Add To Cart";
  let metal_position = 0;
  let shape_position = 0;

  const productOptions = product.options;
  productOptions.forEach((item, index) => {
    if (item === "Color") {
      metal_position = index + 1;
    }
    if (item === "Shape") {
      shape_position = index + 1;
    }
  });

  const shapeOption = 'option' + shape_position;
  const colorOption = 'option' + metal_position;
  var variantId = getParameterByName('variant');

  if (variantId) {
      const variants = document.querySelectorAll('select[data-variants] option');

    variants.forEach((variant) => {
      if ( variant.value === variantId ){
          const color = variant.getAttribute('data-'+colorOption);
          const shape = variant.getAttribute('data-'+shapeOption);
          const colorSwatches = document.querySelectorAll('.metal-swatch-input');
          if (colorSwatches) {
              colorSwatches.forEach((colorSwatch) => {
              if (colorSwatch.value.toLowerCase() === color){
                  colorSwatch.setAttribute('checked', 'checked')
              }
              })
          }
          const shapeSwatches = document.querySelectorAll('.shape-swatch-input');
          if (shapeSwatches){
              shapeSwatches.forEach((shapeSwatch) => {
              if (shapeSwatch.value.toLowerCase() === shape){
                shapeSwatch.setAttribute('checked', 'checked')
              }
            })
          }
        }
    })
  }

  const swatchShapes = document.querySelectorAll('.swatch');
  swatchShapes.forEach((swatchShape) => {
    swatchShape.addEventListener('click', (e) => {
      trigger(e, colorOption, shapeOption)
    }, false);
  })
}

function updateProduct(target) {
    // fallback for default only
    if (defaultOnly) {
        // check if available
        if (product.available) {
            document.querySelector("#productATC").disabled = false;
            document.querySelector("#productATC").textContent = "Add To Cart";
            console.log("available and default")
            // check if the variant is out of stock
            if (parseInt(variantInventory[activeVariant.id]) < 1) {
                // if out of stock but available,then product will be handmade
                console.log("handmade");
                document.querySelector(".productInnerContentHandmade").classList.add("active");
            }

            // if available and has inventory, then product will be ready to ship
            if (parseInt(variantInventory[activeVariant.id]) > 0) {
                document.querySelector(".productInnerContentReady").classList.add("active");
            }

        } else {
            document.querySelector("#productATC").disabled = true;
            document.querySelector("#productATC").textContent = "Sold Out";
        }
        // update price
        document.querySelector("#productInnerContentPrice").textContent = price(activeVariant.price * quantity);
        return;
    }


    //Change Color radio label
    document.querySelectorAll(`input.productInnerContentOptionColorRadio:checked`).forEach(element => {
        document.querySelector('.productInnerContentOptionColorTitle').innerHTML = element.value;
    });

    if (document.querySelector(".unbridaled-form")) {
      document.querySelectorAll(`input.productInnerContentOptionShapeRadio:checked`).forEach(element => {
          document.querySelector('.productInnerContentOptionShapeTitle').innerHTML = element.value;
      });
    }

    //Change radio label
    // Each radio input has a data target attribute, which is the id of the element to update
    let escapedTarget = CSS.escape(target);
    document.querySelectorAll(`[data-target="${escapedTarget}"].productInnerContentOptionDropBodyRadioInput:checked`).forEach(element => {
        document.querySelector(`[id="${escapedTarget}"].productInnerContentOptionDropTitleChoice`).innerHTML = element.value;
    });


    // collect options from inputs
    let options = [];

    // Push options from color
    document.querySelectorAll(`input.productInnerContentOptionColorRadio:checked`).forEach(element => {
        options.push(element.value);
    });

    if (document.querySelector(".unbridaled-form")) {
      document.querySelectorAll(`input.productInnerContentOptionShapeRadio:checked`).forEach(element => {
          options.push(element.value);
      });
    }

    // Push options from select
    document.querySelectorAll(`select.productInnerContentOptionItem`).forEach(element => {
        options.push(element.value)
    });

    // find new variant based on the options
    activeVariant = product.variants.find((variant) => {
        // clean arrays - make case-insensitive comparison
        let variantOptions = variant.options
            .filter(item => typeof item !== 'number')
            .map(item => String(item).toLowerCase())
            .sort(); // Sort the array

        let foundOptions = options
            .filter(item => typeof item !== 'number')
            .map(item => String(item).toLowerCase())
            .sort(); // Sort the array

        // Check if the cleaned/sorted arrays match
        return JSON.stringify(variantOptions) === JSON.stringify(foundOptions);
    });

    // check if variant wasn't found
    if (!activeVariant) {
        // document.querySelector("#productATC").disabled = true;
        document.querySelector("#productATC").textContent = "Please Select an Option";
        return;
    }

    // update image if there is a featured image
    if (activeVariant.featured_image) {
        // change active slide
        productImages.slideTo(activeVariant.featured_image.position);
    }

    // update price
    document.querySelector("#productInnerContentPrice").textContent = price(activeVariant.price * quantity);

    // check if active variant has inventory
    // if so then above button text = Ready to Ship
    // if not then above button text = Handmade to Order
    if (parseInt(variantInventory[activeVariant.id]) > 0) {
        document.querySelector(".productInnerContentReady").classList.add("active");
        document.querySelector(".productInnerContentHandmade").classList.remove("active");
    } else {
        document.querySelector(".productInnerContentHandmade").classList.add("active");
        document.querySelector(".productInnerContentReady").classList.remove("active");
    }

    // if variant has only 1 in stock show "only 1 left" message
    if (parseInt(variantInventory[activeVariant.id]) === 1) {
        document.querySelector(".productInnerContentControlTitle").classList.add("active");
    } else {
        document.querySelector(".productInnerContentControlTitle").classList.remove("active");
    }

    // check if the variant is in stock
    if (activeVariant.available) {
        // document.querySelector("#productATC").disabled = false;
        document.querySelector("#productATC").textContent = "Add To Cart";
    } else {
        // document.querySelector("#productATC").disabled = true;
        document.querySelector("#productATC").textContent = "Sold Out";
        document.querySelector(".productInnerContentReady").classList.remove("active");
        document.querySelector(".productInnerContentHandmade").classList.remove("active");
    }
}


/****************
 * Product Quantity
 */

// minus
document.querySelector("#productInnerContentControlQtyMinus").addEventListener("click", function () {
    // must not be less than 1
    if (quantity === 1) {
        return;
    }

    // decrement by 1
    quantity--;
    document.querySelector("#productInnerContentControlQtyValue").textContent = quantity;
    updateProduct();
});

// plus
document.querySelector("#productInnerContentControlQtyPlus").addEventListener("click", function () {
    // increment by 1
    quantity++;
    document.querySelector("#productInnerContentControlQtyValue").textContent = quantity;
    updateProduct();
});

/**************
 Product ATC
 ***************/

document.querySelector("#productATC").addEventListener("click", async function (e) {
    e.preventDefault();
    // for each unchecked option show an error message
    console.log("uncheckedOptions====>", uncheckedOptions)
    for (let i = 0; i < uncheckedOptions.length; i++) {
        // find the element with the same data-target as the unchecked option
        let element = document.querySelector(`[data-target="${CSS.escape(uncheckedOptions[i])}"]`);
        console.log("element====>", element)
        // show error
        element.innerText = "Please Select an Option";
        element.classList.add("active");

        // don't allow checkout if there are unchecked options
        return;
    }

    // check if active variant not found
    if (!activeVariant) {
        // don't allow checkout
        return;
    }

    // add loading animation
    this.classList.add("loading");


    let formData = {
        items: [{
            quantity: quantity,
            id: activeVariant.id,
        }]
    };

    //allow to add product properties to the cart items
    if (document.querySelectorAll("input[name^='properties']")) {
      const regex = /\[(.*?)\]/g;
      document.querySelectorAll("input[name^='properties']").forEach((property) => {
        const match = property.name.match(regex);
        const propertyName = match ? match[0].replace(/[\[\]]/g, '') : null;
        if (propertyName){
          if (!formData.items[0].hasOwnProperty('properties')) {
            formData.items[0].properties = {};
          }
          formData.items[0].properties[propertyName] = property.value; 
        }
      })
    }

    // check for subscription
    if (document.querySelector("#productSubscribes:checked")) {
        formData.items[0].selling_plan = parseInt(document.querySelector("#productPlanItemPlans").value)
    }

    // add product
    await addProduct(formData);


    // remove loading animation
    this.classList.remove("loading");

    // open cart
    await openCart()
});


//faq event listeners for each of the questions
document.querySelectorAll(`#product .productInnerContentDropdownItemTitle`).forEach(function (element) {
    element.addEventListener("click", function () {
        this.parentElement.classList.toggle("active");
    });
});
//faq event listeners for each of the option menus
document.querySelectorAll(`#product .dropdown`).forEach(function (element) {
    element.addEventListener("click", function () {
        this.parentElement.classList.toggle("active");
    });
});


/**************
 Hide reviews widget with 0 reviews
 ***************/

fetch("https://stamped.io/api/widget/badges", {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
    },
    body: JSON.stringify({
        productIds: [
            {
                productId: product.id
            },
        ],
        apiKey: 'pubkey-3y7z7Mj8g3kwpV6595G40TUUcv8b5D',
        storeUrl: 'loveaudryrose-com.myshopify.com',
    }),
})
    .then(response => response.json())
    .then(response => {
        // if there are no reviews, hide it
        if (response[0].count === 0) {
            document.querySelector("#stamped-main-widget").classList.add("active");
        }
    });

/**************
 Dynamic option dropdowns
 ***************/

// check if there is only one option
if (uncheckedOptions.length === 1) {
    // for all the options
    document.querySelectorAll(`select.productInnerContentOptionItem option`).forEach(element => {
        // find the options variant id
        let variantId = product.variants.find((id) => {
            return JSON.stringify(id.options[0]) === JSON.stringify(element.value);
        });

        // check if the variant was found
        if (variantId && variantId.id) {
            // check if the variant has inventory
            if (variantInventory[variantId.id] > 0 && variantId.available) {
                // add to dropdown
                element.disabled = false;
                element.textContent = element.textContent + " (Ready to Ship)";
            }
        }
    });
}